import type { TimeWindow } from '../data/types';
import { TIME_WINDOW_LABELS } from '../data/types';

interface Props {
  value: TimeWindow;
  onChange: (value: TimeWindow) => void;
}

const OPTIONS: TimeWindow[] = ['7d', '30d', '90d', 'season'];

export function CiTimeWindowTabs({ value, onChange }: Props) {
  return (
    <div className="ci-tabs" role="tablist" aria-label="Fenêtre temporelle">
      {OPTIONS.map((opt) => (
        <button
          key={opt}
          type="button"
          role="tab"
          aria-selected={value === opt}
          className={`ci-tabs__btn${value === opt ? ' is-active' : ''}`}
          onClick={() => onChange(opt)}
          data-testid={`ci-window-${opt}`}
        >
          {TIME_WINDOW_LABELS[opt]}
        </button>
      ))}
    </div>
  );
}
